export enum DownloadExcel {
  ExportFilterMappingsEnabled = 'ExportFilterMappingsEnabled',
  ExportBaseMappingEnabled = 'ExportBaseMappingEnabled',
  OnBoardedAppsEnabled = 'OnBoardedAppsEnabled'
}
